import { useMutation } from 'react-query';

import { TRIAL_START_QUERY_KEYS } from '../constants';
import {
  requestTrialStart,
  type TrialStartRequestPayload,
  type TrialStartResponse,
} from '../request';

type TrialStartVariables = {
  values: TrialStartRequestPayload;
  signal?: AbortSignal;
};

export const useTrialStartMutation = () =>
  useMutation<TrialStartResponse, Error, TrialStartVariables>(
    [TRIAL_START_QUERY_KEYS.START],
    ({ values, signal }: TrialStartVariables) =>
      requestTrialStart(values, signal)
  );
